/**
 * Route path constants.
 *
 * Centralized path definitions to avoid string duplication.
 */

export const ROUTES = {
  HOME: '/',
  ABOUT: '/about',
  STANDARDS: '/standards',
  HOW_IT_WORKS: '/how-it-works',
  FAQ: '/faq',
  RESOURCES: '/resources',
  APPLY: '/apply',
  APPLICATION: '/application',
  CONTACT: '/contact',
  PRIVACY: '/privacy',
  TERMS: '/terms',
  REGISTRY: '/registry',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  VERIFY_EMAIL: '/verify-email',
  DASHBOARD: '/dashboard',
  DASHBOARD_PROFILE: '/dashboard/profile',
  DASHBOARD_COMMUNITY: '/dashboard/community',
  DASHBOARD_EVENTS: '/dashboard/events',
  DASHBOARD_CONTENT: '/dashboard/content',
  DASHBOARD_ANALYTICS: '/dashboard/analytics',
  DASHBOARD_NOTIFICATIONS: '/dashboard/notifications',
  DASHBOARD_SETTINGS: '/dashboard/settings',
  ADMIN: '/admin',
  ADMIN_MONITORING: '/admin/monitoring',
  WORKSPACE: '/workspace',
  WORKSPACE_OVERVIEW: '/workspace',
  WORKSPACE_PROFILE: '/workspace/profile',
  WORKSPACE_APPLICATION: '/workspace/application',
  WORKSPACE_STATUS: '/workspace/status',
  WORKSPACE_ACCOUNT: '/workspace/account',
  WORKSPACE_NOTIFICATIONS: '/workspace/notifications',
  REVIEW: '/review',
  REVIEW_OVERVIEW: '/review',
  REVIEW_QUEUE: '/review/queue',
  REVIEW_DETAILS: '/review/applications',
  REVIEW_HISTORY: '/review/history',
  REVIEW_SEARCH: '/review/search',
  REVIEW_SETTINGS: '/review/settings',
  NOT_FOUND: '*',
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];
